import "../Css/_index.scss";
import './Core/_core';

import { defineCustomElements } from "@what3words/javascript-components/loader";
defineCustomElements(window);